import React, { useEffect, useState, useContext } from "react";
import { X } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import useFacebookOnboarding from "../../services/Whatsapp/useFacebookOnboarding";
import { GlobalContext } from "../../Context/GlobalContext";
import onboard from "../../images/onboardimage.png";
import image1 from "../../images/image1.png";
import image2 from "../../images/image2.webp";
import image3 from "../../images/image3.png";
import image4 from "../../images/image4.webp";
import image5 from "../../images/image5.png";
import "./FacebookOnBoarding.css";

const FacebookOnboarding = () => {
  const { userID } = useContext(GlobalContext);
  const { pushWebhookData, registerMobileNumber } = useFacebookOnboarding();

  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState("");
  const [isFlowStarted, setIsFlowStarted] = useState(false);
  const [isFBReady, setIsFBReady] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [configID, setConfigID] = useState("");

  const ConfigID1 = "586221150782928";
  const ConfigID2 = "1164797434986506";

  const connectionSteps = [
    {
      number: 1,
      title: "Login to Facebook",
      description:
        "Ensure it's the admin account for your meta Business Manager.",
      image: image1,
    },
    {
      number: 2,
      title: "Fill Your Business Information",
      description: "Fill your Business information.",
      image: image2,
    },
    {
      number: 3,
      title: "Create New WhatsApp",
      description: "Create New WhatsApp business account & profile.",
      image: image3,
    },
    {
      number: 4,
      title: "Fill WhatsApp Business Profile info",
      description: "Fill WhatsApp Business profile.",
      image: image4,
    },
    {
      number: 5,
      title: "Verify your Business number on Meta",
      description: "Final step to connect your WhatsApp Business account.",
      image: image5,
    },
  ];

  const images = [image1, image2, image3, image4, image5];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState(null);

  const goToNext = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setSlideDirection("left");
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrev = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setSlideDirection("right");
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length,
    );
  };

  const getNextIndex = () => (currentIndex + 1) % images.length;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
      setSlideDirection(null);
    }, 600);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  const getSlideClassName = (index) => {
    if (index === currentIndex) {
      return `carousel-slide active ${isAnimating ? `sliding-${slideDirection}` : ""}`;
    }
    if (index === getNextIndex()) {
      return "carousel-slide next";
    }
    return "carousel-slide prev";
  };

  //
  const updateSteps = (e) => {
    const targetId = e.currentTarget.id;
    setCurrentStep((prevStep) =>
      targetId === "next" ? prevStep + 1 : prevStep - 1,
    );
    if (targetId === "next") {
      goToNext();
    } else {
      goToPrev();
    }
  };

  // ================= FB SDK =================
  useEffect(() => {
    if (window.FB) {
      window.FB.init({
        appId: "801281555533147",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v21.0",
      });
      setIsFBReady(true);
      return;
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "801281555533147",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v21.0",
      });
      setIsFBReady(true);
    };

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const pushResponseCall = async (responseData) => {
    if (!responseData) return;

    try {
      const res = await pushWebhookData(responseData);
      if (res?.responseCode === "00") {
        toast.success(res.responseMessage);
        registerMobileNumber(userID);
      } else {
        toast.error(res?.responseMessage || "Something went wrong");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("API Error:", error);
    }
  };

  const fbLoginCallback = (response) => {
    if (response.authResponse) {
      pushResponseCall({ ...response, userid: userID });
      toast.success("Successfully connected to Facebook!");
    } else {
      toast.error("Facebook login failed. Please try again.");
    }
  };

  // ================= launchWhatsAppSignup =================
  const launchWhatsAppSignup = () => {
    if (!window.FB) {
      toast.error("Facebook SDK load nahi hua. Page reload karein.");
      return;
    }

    if (!configID) {
      toast.error("Configuration missing. Please start again.");
      return;
    }
    window.FB.login(fbLoginCallback, {
      config_id: configID,
      response_type: "code",
      override_default_response_type: true,
      extras: { version: "v3" }, 
      // marked by Hemant
    });
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }
      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
          if (data.event === "FINISH") {
            const { phone_number_id, waba_id } = data.data;
            pushResponseCall({ ...data, userid: userID });
            console.log(
              "Phone number ID ",
              phone_number_id,
              " WhatsApp business account ID ",
              waba_id,
            );
          } else if (data.event === "CANCEL") {
            const { current_step } = data.data;
            console.warn("Cancel at ", current_step);
          } else if (data.event === "ERROR") {
            const { error_message } = data.data;
            console.error("error ", error_message);
          }
        }
      } catch {}
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <>
    <ToastContainer/>
    <div className="p-6 montserrat-font-1">
      {!isFlowStarted ? (
        <div className="flex bg-white rounded-xl border overflow-hidden">
          <div className="w-1/3 bg-orange-100 flex items-center justify-center">
            <img src={onboard} alt="Onboarding" />
          </div>
          <div className="w-2/3 p-6 bg-green-50">
            <h2 className="text-2xl font-semibold mb-2">
              To Experience Messaging, Please connect your{" "}
              <span className="text-green-600 font-bold">WhatsApp</span> number.
            </h2>
            <p className="text-gray-500 mb-4 montserrat-font-2">
              You can connect your WhatsApp Number to start messaging contacts
              or receive messages from them.
            </p>
            <h4 className="text-xl font-semibold mb-2">
              Few things to know before you connect
            </h4>
            <ul className="text-sm text-gray-600 mb-5 space-y-1">
              <li className="mb-4">
                → You must have Admin access to your Meta Business Manager
              </li>
              <li>
                → You must have a phone number that does not have a WhatsApp
                Account
              </li>
              <li className="pt-2">
                • Deregister number that has been with WhatsApp Business before.
              </li>
            </ul>
            <button
              onClick={() => setShowModal(true)}
              className="bg-blue-500 text-white px-5 py-2 mt-3 rounded"
            >
              Connect Now
            </button>
          </div>
        </div>
      ) : (
        <div className="flex gap-20">
          {/* ===== LEFT STEPPER ===== */}
        <div className="w-[35%] bg-white rounded-xl p-4 border max-h-[650px] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-2">
              You are almost there..!
            </h3>
            <p className="text-gray-500 mb-4 montserrat-font-2">
              Ensure it's the admin account for your meta Business Manager.
            </p>

            <div className="flex">
              {/* STEPS */}

              <div className="flex flex-col">
                {connectionSteps.map((step, index) => {
                  const isLast = index === connectionSteps.length - 1;
                  const status =
                    index < currentStep
                      ? "done"
                      : index === currentStep
                        ? "active"
                        : "pending";

                  return (
                    <div key={index} className="flex gap-3">
                      <div className="flex flex-col items-center flex-shrink-0">
                        <div
                          className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-medium z-10 transition-colors duration-300
            ${
              status === "done"
                ? "bg-green-500 text-white"
                : status === "active"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-500"
            }`}
                        >
                          {index + 1}
                        </div>

                        {!isLast && (
                          <div
                            className={`w-0.5 flex-1 min-h-[32px] my-0.5 transition-colors duration-300
              ${index < currentStep ? "bg-green-500" : "bg-gray-200"}`}
                          />
                        )}
                      </div>

                      {/* Text */}
                      <div className={`${isLast ? "pb-0" : "pb-5"}`}>
                        <p
                          className={`text-md font-medium transition-colors duration-300
            ${status !== "pending" ? "text-gray-900" : "text-gray-400"}`}
                        >
                          {step.title}
                        </p>
                        <p
                          className={`text-sm mt-0.5 transition-colors duration-300
            ${
              status === "done"
                ? "text-green-600"
                : status === "active"
                  ? "text-blue-500"
                  : "text-gray-400"
            }`}
                        >
                          {step.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-5 mt-10">
              <button
                id="prev"
                disabled={currentStep === 0}
                onClick={updateSteps}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
              >
                Previous
              </button>
              <button
                id="next"
                onClick={currentStep === 4 ? launchWhatsAppSignup : updateSteps}
                className="px-4 py-2 bg-green-500 text-white rounded"
              >
                {currentStep === 4 ? "Connect Now" : "Next"}
              </button>
            </div>
          </div>

         <div className="w-[65%] bg-white rounded-xl p-5 border max-h-[650px] overflow-hidden">
            <h4 className="font-semibold mb-1">
              {connectionSteps[currentStep].title}
            </h4>
            <p className="text-gray-500 mb-3 text-sm">
              {connectionSteps[currentStep].description}
            </p>

            <div className="carousel-container">
              <div className="carousel-track">
                {images.map((image, index) => (
                  <div key={index} className={getSlideClassName(index)}>
                    <img src={image} alt={`Slide ${index}`} draggable="false" />
                  </div>
                ))}

                <div className="carousel-dots">
                  {images.map((_, index) => (
                    <button
                      key={index}
                      className={`carousel-dot ${index === currentIndex ? "active" : ""}`}
                      onClick={() => {
                        if (!isAnimating) {
                          setIsAnimating(true);
                          setSlideDirection(
                            index > currentIndex ? "left" : "right",
                          );
                          setCurrentIndex(index);
                          setCurrentStep(index);
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= MODAL ================= */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
          <div className="bg-white w-[500px] rounded-lg shadow-xl">
            <div className="flex justify-between items-start p-4 border-b">
              <h3 className="text-sm font-medium pr-4">
                Select messaging only or messaging with a catalogue to fit your
                business needs.
              </h3>
              <X
                className="cursor-pointer flex-shrink-0"
                onClick={() => setShowModal(false)}
              />
            </div>
            <div className="p-4 space-y-3">
              <label className="flex gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="type"
                  value="messaging"
                  checked={selected === "messaging"}
                  onChange={(e) => setSelected(e.target.value)}
                />
                <div>
                  <p className="font-medium">WhatsApp Messaging</p>
                  <p className="text-sm text-gray-500 montserrat-font-2">
                    Communicate with your customers seamlessly via chat for
                    support and engagement.
                  </p>
                </div>
              </label>
              <label className="flex gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="type"
                  value="catalogue"
                  checked={selected === "catalogue"}
                  onChange={(e) => setSelected(e.target.value)}
                />
                <div>
                  <p className="font-medium">
                    WhatsApp Messaging with Catalogue
                  </p>
                  <p className="text-sm text-gray-500 montserrat-font-2">
                    Showcase your products or services alongside messaging for a
                    complete shopping experience.
                  </p>
                </div>
              </label>
            </div>
            <div className="flex justify-end gap-3 p-4 border-t">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                disabled={!selected}
                onClick={() => {
                  setConfigID(selected === "catalogue" ? ConfigID2 : ConfigID1);
                  setShowModal(false);
                  setIsFlowStarted(true);
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default FacebookOnboarding;
